// This is data that is defined by the server see PageHelper:getServerData
module.exports = window.serverData || {}
module.exports.default = window.serverData
